var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "homeWrapper",
      staticClass: "wrapper home-wrapper",
      style: { "z-index": _vm.transitionStart ? 1111 : "auto" }
    },
    [
      _c(
        "div",
        { ref: "homeBox", staticClass: "ll" },
        [
          _c("div", { ref: "hHead", staticClass: "h-head" }, [
            _c("div", { staticClass: "flexBox" }, [
              _c(
                "div",
                {
                  staticClass: "u-tree-menu flexBox",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "treeMenu" })
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/static/images/navs/treeMenu.png" }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("知识目录")])
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "u-search flexItem flexBox",
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "searchKnowledge" })
                    }
                  }
                },
                [
                  _c("i", { staticClass: "icon icon-search" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "p-text" }, [
                    _vm._v("你有什么想了解的？")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "self-service-box mt-70" }, [
              _c(
                "div",
                { staticClass: "service-items flexBox" },
                _vm._l(_vm.serviceDefaultObj.List, function(service, index) {
                  return _c(
                    "div",
                    {
                      staticClass: "service-item flexBox",
                      on: {
                        click: function($event) {
                          return _vm.actionEmit(service)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "service-icon",
                        attrs: { src: service.Icon }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "service-name",
                        domProps: { textContent: _vm._s(service.Name) }
                      })
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "service-down-icon" }, [
                _c("img", {
                  staticClass: "arrow-down",
                  attrs: { src: "/static/images/icon/arrow_down.svg" },
                  on: { click: _vm.slideDown }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "hHeadFix",
              staticClass: "h-head h-head-fixed",
              class: { headVisible: _vm.transitionStart },
              on: { touchstart: _vm.touchStart, touchmove: _vm.touchMove }
            },
            [
              _c(
                "div",
                { staticClass: "h-head-fixed-inner" },
                [
                  _c(
                    "fade-transition",
                    {
                      attrs: { duration: 666 },
                      on: {
                        afterEnter: _vm.afterEnter,
                        beforeLeave: _vm.beforeLeave,
                        afterLeave: _vm.afterLeave
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.expandShow,
                              expression: "expandShow"
                            }
                          ]
                        },
                        [
                          _c("h2", { staticClass: "service-head" }, [
                            _vm._v("自助服务")
                          ]),
                          _vm._v(" "),
                          _c("h3", {
                            staticClass:
                              "service-group-name service-group-name-spec",
                            domProps: {
                              textContent: _vm._s(
                                _vm.serviceDefaultObj.Category
                              )
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "self-service-box" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "service-items service-items-default flexBox"
                        },
                        _vm._l(_vm.serviceDefaultObj.List, function(
                          service,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              staticClass: "service-item flexBox",
                              class: { "service-wins-item": _vm.isWinsClient },
                              on: {
                                click: function($event) {
                                  return _vm.actionEmit(service)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "service-icon",
                                attrs: { src: service.Icon }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "service-name",
                                domProps: { textContent: _vm._s(service.Name) }
                              })
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("collapse-transition", { attrs: { duration: 666 } }, [
                        _c(
                          "section",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.expandShow,
                                expression: "expandShow"
                              }
                            ],
                            staticClass: "service-group"
                          },
                          [
                            _vm._l(_vm.serviceExpandList, function(
                              serviceGroup,
                              index
                            ) {
                              return [
                                _c("h3", {
                                  staticClass: "service-group-name",
                                  domProps: {
                                    textContent: _vm._s(serviceGroup.Category)
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "service-items service-transition-items flexBox"
                                  },
                                  _vm._l(serviceGroup.List, function(service) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "service-item flexBox",
                                        class: {
                                          "service-wins-item": _vm.isWinsClient
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.actionEmit(service)
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "service-icon",
                                          attrs: { src: service.Icon }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "service-name",
                                          domProps: {
                                            textContent: _vm._s(service.Name)
                                          }
                                        })
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("fade-transition", { attrs: { duration: 666 } }, [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.expandShow,
                  expression: "expandShow"
                }
              ],
              staticClass: "dialog-mask",
              on: {
                click: _vm.slideUp,
                touchmove: function($event) {
                  $event.preventDefault()
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.iconCtrl
            ? _c(
                "fade-transition",
                { on: { beforeLeave: _vm.iconBeforeLeave } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showUpIcon,
                          expression: "showUpIcon"
                        }
                      ],
                      ref: "upIcon",
                      staticClass: "service-up-icon",
                      on: { click: _vm.slideUp }
                    },
                    [
                      _c("img", {
                        staticClass: "arrow-up",
                        attrs: { src: "/static/images/icon/arrow_up.svg" }
                      })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "h-fixed-tab-wrap" }, [
            _c(
              "div",
              {
                ref: "hfixedtab",
                staticClass: "h-fixed-tab",
                attrs: { id: "fScroll" }
              },
              [
                _c(
                  "div",
                  { ref: "fbox", staticClass: "f-box" },
                  _vm._l(_vm.topicList, function(ftab, index) {
                    return _c(
                      "span",
                      {
                        staticClass: "f-tab-bullet",
                        class: { active: _vm.swiperIndex == index },
                        on: {
                          click: function($event) {
                            return _vm.clickTab(index)
                          }
                        }
                      },
                      [
                        _c("span", {
                          class: { updated: !ftab.IsRead },
                          domProps: { textContent: _vm._s(ftab.Name) }
                        })
                      ]
                    )
                  }),
                  0
                )
              ]
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "tab-search-icon icon icon-search flexBox",
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "searchKnowledge" })
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "h-main-content" },
            [
              _c("h3", { staticClass: "h-plaintext" }, [_vm._v("知识推荐")]),
              _vm._v(" "),
              _c(
                "swiper",
                {
                  ref: "topicTitleSwiper",
                  staticClass: "topic-swiper",
                  attrs: { options: _vm.topicSwiperOption }
                },
                _vm._l(_vm.topicList, function(ctab, index) {
                  return _c(
                    "swiper-slide",
                    {
                      key: index,
                      staticClass: "topic-swiper-slide",
                      class: {
                        "topic-swiper-slide-active": index === _vm.swiperIndex
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "topic-item",
                          on: {
                            click: function($event) {
                              return _vm.ClickTopicSwiper(index)
                            }
                          }
                        },
                        [
                          _c("img", { attrs: { src: ctab.ImgUrl } }),
                          _vm._v(" "),
                          _c("p", { staticClass: "topic-title flexBox" }, [
                            _c("span", {
                              class: {
                                blank: ctab.Name == "",
                                updated: !ctab.IsRead
                              },
                              domProps: { textContent: _vm._s(ctab.Name) }
                            })
                          ])
                        ]
                      )
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "swiper",
                {
                  ref: "topicListSwiper",
                  staticClass: "h-lists-box",
                  attrs: { options: _vm.swiperOption }
                },
                _vm._l(_vm.topicList, function(tabqlist, index) {
                  return _c(
                    "swiper-slide",
                    {
                      key: index,
                      staticClass: "lists",
                      attrs: { sign: "lists-" + index }
                    },
                    [
                      _c("result-list2", {
                        attrs: {
                          lists: _vm.topicItemList[index],
                          LogId: _vm.LogId,
                          firstTab: index === 0 ? true : false
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-7eb2bc79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7eb2bc79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = null
// module chunks = 